import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { updateProject } from 'actions/projects';

import { createAlert } from 'services/alert-service';

import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

import ProjectContainer from 'containers/project-container';

import FieldAvatar from 'components/field-avatar';
import AvatarBase from 'components/avatar-base';
import Tooltip from 'components/tooltip';

const ProjectAvatar = ({ id, size, withEdit }) => {
    const { t } = useTranslation(['project', 'settings'])
    const rolesAndPermissions = useContext(RolesAndPermissionsContext);
    const [logoState, setLogoState] = useState(null);

    const uploadLogo = fileObject => {

        if (!fileObject) {
            return new Promise(res => res());
        }

        return updateProject(id, {
            logo: fileObject.file,
            logoBase64: fileObject.base64
        }).then(() => {
            createAlert('success', t('alerts.logoUpdated'), {
                duration: 3000
            });
        });
    }

    const handleLogoChange = ([ fileObject ]) => {
        uploadLogo(fileObject);
        setLogoState(fileObject.base64);
    }

    return (
        <ProjectContainer id={id}>
            {
                ({ logo, initials, color, secondary_color, owner }) => withEdit ? (
                    <Tooltip tooltip={(logoState || logo) ? t('settings:Upload a new logo') : t('settings:Upload a logo')} placement="top" withTooltipHover={false} showDelay={200}>
                        <div>
                            <FieldAvatar
                                size={size}
                                image={logoState || logo}
                                color={color}
                                secondaryColor={secondary_color}
                                text={initials}
                                readOnly={!rolesAndPermissions?.canUser('editProject', owner)}
                                onChange={handleLogoChange}
                            />
                        </div>
                    </Tooltip>
                ) : (
                    <AvatarBase size={size} image={logo} text={initials} color={color} secondaryColor={secondary_color} />
                )
            }
        </ProjectContainer>
    );
}

export default ProjectAvatar;
